import { Stages } from '@urbanx/agx.activities.client';


export const AvailableStageCategories = Object.values(
  Stages
) as Stages[];